export const environment = {
  production: true,
  urlPrefix: window.document.location.protocol+'//'+window.document.location.hostname+((window.document.location.port!=null && window.document.location.port!='')?(':'+window.document.location.port):'')+'/japp.server.frontend',
  sitePrefix: window.document.location.protocol+'//'+window.document.location.hostname+((window.document.location.port!=null && window.document.location.port!='')?(':'+window.document.location.port):''),
  fakeUser: null,
  fakeRoles: null

};
